module.exports = __webpack_public_path__ + "img/large-circle.51d37538.png";